import { ThanksPageType } from "@funded-here-interface/common/src/constant/enum";

/**
 * Helper to get thank you page URL with query parameters.
 */
export const getThanksPageUrl = (
  type: ThanksPageType,
  additionalParams?: Record<string, string>,
): string => {
  const params = new URLSearchParams({
    type,
    ...additionalParams,
  });

  return `/thanks?${params.toString()}`;
};

/**
 * Navigation path constants
 * Centralizes route paths to avoid string duplication and typos
 */

export const NAVIGATION_PATHS = {
  // Investor paths
  IND_BIZ_PROFILE: "/ind-biz-profile",
  BIZ_PROFILE: "/biz-profile",
  DECLARATION_AI: "/declaration-ai",
  UNQUALIFIED_INVESTOR: "/unqualified-investor",
  NOTE_OFFER_ROOM: "/offer-room",

  // Merchant paths
  NEW_MERCHANT_ONBOARD: "/new-merchant-onboard",
  BMCA_FORM: "/bmca-form",
  MERCHANT_MEMBERSHIP_AGREEMENT: "/merchant/onboarding/membership-agreement",

  // Shareholder/Director paths
  PENDING_SHAREHOLDER_ONBOARD: "/pending-shareholder-onboard",
  DIRECTOR_BOARD_RESOLUTION: "/director-board-resolution",
  ISSUER_BOARD_RESOLUTION: "/issuer-board-resolution",

  // Distributor paths
  SUPPLIER_BIZ_PROFILE: "/supplier-biz-profile",
  UPLOAD_INVOICE: "/upload-invoice",

  // Agreement/Loan paths
  ISSUER_AGREEMENT: "/issuer-agreement",
  LOAN_AGREEMENT: "/collaboration-proposal/agreement",
  COLLABORATION_PROPOSAL: "/collaboration-proposal/application",

  // Thanks/Status pages
  THANKS_PAGE: "/thanks-page",
  REGTANK_RESPONSE: "/regtank-response",
  FUNDING_ISSUING_SPV_ONBOARD_COMPLETED: "/funding-issuing-spv-onboard-completed",
} as const;
